import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { DailyDiaryViewModel } from "./DailyDiaryViewModel";
import { uniqueId } from "lodash-es";
import { DailyDiaryQuestionView } from "./DailyDiaryQuestionView";
import { SHBox } from "Components/Box";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import { DashedDivider } from "../../../PurchaseOrder/Form/Views/Dividers";
import styled from "styled-components";
import { Loader } from "@shoothill/core";
import { DeleteModal } from "Components/Modal/DeleteModal";

interface Props {
    date: Date;
    projectId: string;
}
export const DailyDiaryView: React.FC<Props> = observer((props: Props) => {
    const [viewModel] = useState(() => new DailyDiaryViewModel());
    const [showSubmitDailyChecklistModal, setShowSubmitDailyChecklistModal] = useState<boolean>(false);

    useEffect(() => {
        viewModel.setValue("projectId", props.projectId);
        viewModel.date = props.date;
        viewModel.getDailyDiary();
    }, [props.date]);

    const handleSubmitDailyChecklistEmail = async () => {
        if (await viewModel.isModelValid()) {
            setShowSubmitDailyChecklistModal(false);
            viewModel.submit();
        }
    };

    return (
        <SHBox p={3}>
            <SubmissionContainer>
                {!viewModel.model.isSubmitted && (
                    <div>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                                if (await viewModel.isMyModelValid()) {
                                    setShowSubmitDailyChecklistModal(true);
                                }
                            }}
                            disabled={viewModel.IsLoading || viewModel.model.isSubmitted}
                        >
                            {viewModel.IsLoading ? <CircularProgress size={20} /> : "Submit"}
                        </Button>
                    </div>
                )}

                {viewModel.model.isSubmitted && (
                    <div>
                        <Typography variant={"h5"} style={{ color: "green" }}>
                            Submitted date: {viewModel.submittedDateFormatted}
                        </Typography>
                        <Typography variant={"h5"} style={{ color: "green" }}>
                            Submitted by: {viewModel.model.submittedByUserName}
                        </Typography>
                    </div>
                )}
            </SubmissionContainer>

            <Typography></Typography>
            <SHBox grid dc={"1fr 100px 150px 200px"} mb={2}>
                <Typography></Typography>
                <Typography variant={"h5"}>Complete?</Typography>
                <Typography variant={"h5"}>Completed by</Typography>
                <Typography variant={"h5"}>Reason for not completing</Typography>
            </SHBox>
            <DashedDivider gutterBottom />
            {viewModel.IsLoading && <Loader />}
            {!viewModel.IsLoading &&
                viewModel.dailyDiaryQuestionViewModels.map((itemViewModel) => {
                    return (
                        <SHBox key={uniqueId()}>
                            <DailyDiaryQuestionView viewModel={itemViewModel} disabled={props.date.toDateString() !== new Date().toDateString() || viewModel.model.isSubmitted} />
                            <SHBox pt={2} pb={2}>
                                <DashedDivider />
                            </SHBox>
                        </SHBox>
                    );
                })}
            <DeleteModal
                open={showSubmitDailyChecklistModal}
                onClose={() => setShowSubmitDailyChecklistModal(false)}
                onDelete={handleSubmitDailyChecklistEmail}
                title="Submit daily checklist?"
                text="Are you sure you want to submit the daily checklist?"
                isLoading={viewModel.IsLoading}
            />
        </SHBox>
    );
});

const SubmissionContainer = styled.div`
    display: flex;
    justify-content: right;
    margin-bottom: 15px;
`;
